import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=fe077c5c&scoped=true"
import script from "./GroupManage.vue?vue&type=script&lang=js"
export * from "./GroupManage.vue?vue&type=script&lang=js"
import style0 from "./GroupManage.vue?vue&type=style&index=0&id=fe077c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe077c5c",
  null
  
)

export default component.exports